module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 45 80",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }